<script>
import {
  assessmentUserMethods,
  assessmentMethods,
  assessmentRunSessionMethods,
  intraOccupationalReportMethods,
} from '@state/helpers'
import { mapGetters } from 'vuex'
import CustomMultiselect from '@components/form/customMultiselect.vue'
import QuestionsComponent from './questions/index.vue'
import AssessmentCard from './assessment-card.vue'
// import _ from 'lodash'
export default {
  name: 'AssessmentShowPage',
  components: { CustomMultiselect, QuestionsComponent, AssessmentCard },

  data() {
    return {
      assessmentsOptions: [],
      assessmentSelected: {},
      companySelected: null,
      companyOptions: [],
      //   breadCrumb: [
      //     { text: 'Inicio', to: '/' },
      //     { text: 'Pruebas', active: true },
      //   ],
      visiblePasswordModal: false,
      checkForm: {
        url: null,
        password: null,
      },
      checkingPassword: false,
      visibleQuestions: false,
      fullscreen: false,
      perPage: 6,
      currentPage: 1,
    }
  },

  computed: {
    ...mapGetters({
      assessmentUsers: 'assessment/assessmentUser/assessmentUsers',
      loadingAssessmentUsers:
        'assessment/assessmentUser/loadingAssessmentUsers',
      assessmentRunSession:
        'assessment/assessmentRunSession/assessmentRunSession',
    }),

    currentSession() {
      return this.$store.state.auth.currentSession
    },

    async thirdparties() {
      const { error, data } = await this.AssessmentUserThirdparties()
      if (error) {
        this.$axios_error_noty(error, this)
        this.companyOptions = []
      }
      this.companyOptions = data
    },
  },

  watch: {
    companySelected(val) {
      if (!val) {
        this.noFilter()
      }
      this.getAssessmentUsers()
    },
  },

  mounted() {
    this.getAssessmentUsers()
    this.thirdparties()
  },

  methods: {
    ...assessmentMethods,
    ...assessmentUserMethods,
    ...assessmentRunSessionMethods,
    ...intraOccupationalReportMethods,

    async getAssessmentUsers(page = 1) {
      const user = this.currentSession.user
      this.currentPage = page
      let filter = `?page_size=${this.perPage}${page ? '&page=' + page : ''}
        &assessment__web_status=true${ !user.is_superuser ? `&user=${user.id}` : ''}
        ${ this.companySelected ? `&thirdparty_id=${this.companySelected.id}` : ''}
      `
      const { error} = await this.fetchAssesmentUsers(filter)
      if (error) {
        this.$axios_error_noty(error, this)
      }
      this.noFilter()
    },

    async checkPassword() {
      const payload = this.checkForm
      this.visibleQuestions = false
      this.checkingPassword = true
      const { error, status } = await this.checkPasswordAssessment({
        payload,
      })
      this.checkingPassword = false
      if (error) {
        return this.$axios_error_noty(error, this)
      }
      if (status === 200) {
        // this.$generate_toast(this, 'success', 'Contraseña válida')
        this.checkingPassword = false
        this.visiblePasswordModal = false
        this.visibleQuestions = true
      }
    },
    
    noFilter() {
      const assessments = []
      this.assessmentUsers.results.forEach((au) => {
        const assessment = assessments.find(
          (a) => a.id === au.assessment_detail.id
        )

        if (!assessment) {
          assessments.push(au.assessment_detail)
        }
      })
      this.assessmentsOptions = assessments
    },

    thidpartyFullName({
      brand,
      first_name: firstName,
      last_name: lastName,
      full_name: fullName,
    }) {
      return brand || fullName || `${firstName} ${lastName}`
    },

    toStartAssessment(assessment) {
      this.visibleQuestions = false
      this.assessmentSelected = assessment
      if (assessment.required_password) {
        this.checkForm.url = assessment.url
        this.visiblePasswordModal = true
        return
      }
      this.visibleQuestions = true
    },

    closeQuestionsModal() {
      this.visibleQuestions = false
      this.assessmentSelected = {}
      this.cleanRunSession()
    },

    async toGenerateReports() {
      try {
        const res = await this.generateReports(this.assessmentRunSession.url)
      } catch (error) {
        this.$axios_error_noty(error, this)
      }
    },

    assessmentCompletedSuccessfully() {
      this.$generate_toast(this, 'success', 'La prueba ha finalizado con éxito')
      this.toGenerateReports()
      this.closeQuestionsModal()
    },
  },
}
</script>

<template>
  <Layout>
    <div fluid>
      <!-- <PageHeader title="Pruebas" :items="breadCrumb" /> -->
      <!-- <PageHeader title="Pruebas" /> -->
      <!-- v-if="!visiblePasswordModal" -->
      <b-row align-h="center">
        <b-container>
          <b-row class="d-flex justify-content-center">
            <b-col md="8" class="">
              <b-card class="mt-4 shadow bg-light" body-class='p-0'>
                
                <div v-if="loadingAssessmentUsers" class="text-center my-4">
                  <b-spinner class="align-middle mr-1"></b-spinner>
                  <strong>Cargando</strong>
                </div>
                <div v-else>
                  <!-- <ValidationObserver v-slot="{ handleSubmit }"> -->
                  <b-row align-h="center" align-v="center">
                    <b-col cols="1"><h2><i class="fas fa-building"></i></h2></b-col>
                    <b-col cols="6">
                      <ValidationObserver>
                        <div class="mt-2">
                          <CustomMultiselect
                            name="company"
                            rules="required"
                            :value.sync="companySelected"
                            placeholder="Seleccione una empresa"
                            :options="companyOptions"
                            :custom-label="thidpartyFullName"
                          />
                        </div>
                      </ValidationObserver>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-col>

            <!-- {{ assessmentsOptions.length }} -->
          </b-row>
          <b-row class="d-flex justify-content-center">
            <div v-if="loadingAssessmentUsers" class="text-center my-4">
              <b-spinner class="align-middle mr-1"></b-spinner>
              <strong>Cargando</strong>
            </div>
            <div v-else>
              <h5 class="px-3 text-center">
                Mostrando
                {{
                  !assessmentUsers.count ? 0 : (currentPage - 1) * perPage + 1
                }}
                -
                {{
                  !assessmentUsers.count
                    ? 0
                    : currentPage * perPage >= assessmentUsers.count
                    ? assessmentUsers.count
                    : currentPage * perPage
                }}
                de {{ assessmentUsers.count }} registros totales
              </h5>
              <div class="container d-flex flex-wrap justify-content-center" style="max-width: 1000px">
                <div
                  v-for="(assessment, index) in assessmentsOptions"
                  :key="index"
                >
                  <AssessmentCard
                    :assessment="assessment"
                    :to-start-assessment="toStartAssessment"
                  />
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="d-flex justify-content-center">
            <div class="mt-3">
              <b-pagination
                pills
                v-model="currentPage"
                align="center"
                :total-rows="assessmentUsers.count"
                :per-page="perPage"
                @change="getAssessmentUsers"
              ></b-pagination>
            </div>
          </b-row>
        </b-container>
      </b-row>

      <b-modal
        id="pass-modal"
        v-model="visiblePasswordModal"
        size="sm"
        title="validación de contraseña"
        hide-footer
      >
        <b-col>
          <div>
            <!-- {{ checkForm }} -->
            <b-form-group
              id="input-group-input-password"
              label="Contraseña:"
              label-for="input-password"
            >
              <b-form-input
                id="input-password"
                v-model="checkForm.password"
                :type="'password'"
                placeholder="Ingrese contraseña"
                required
              ></b-form-input>
              <b-button
                class="mt-2"
                block
                :disabled="checkingPassword"
                @click="checkPassword"
              >
                <b-spinner v-if="checkingPassword" small />
                <span v-else>Validar</span>
              </b-button>
            </b-form-group>
          </div>
          <!-- <div v-else class="text-center">
            <b-spinner type="grow" label="Spinning"></b-spinner>
            <b-spinner
              variant="primary"
              type="grow"
              label="Spinning"
              class="mx-2"
            ></b-spinner>
            <b-spinner
              variant="success"
              type="grow"
              label="Spinning"
            ></b-spinner>
          </div> -->
        </b-col>
      </b-modal>

      <!-- </b-card>
            </b-card>
          </b-col>
        </b-row>
      </b-container> -->
      <!---->

      <b-modal
        id="questions-modal"
        v-model="visibleQuestions"
        size="xl"
        title="Prueba"
        hide-footer
        no-close-on-backdrop
        @hide="closeQuestionsModal"
      >
        <QuestionsComponent
          :assessment="assessmentSelected"
          :assessment-completed-successfully="assessmentCompletedSuccessfully"
        />
      </b-modal>
    </div>
  </Layout>
</template>
<style lang="scss">
.card-img,
.card-img-top {
  max-height: 200px;
  min-width: 300px;
}

.scroll-snap-container {
  height: 97%;
  width: 100%;
}
#pass-modal___BV_modal_backdrop_,
#questions-modal___BV_modal_backdrop_ {
  opacity: 2;
}
// .modal-dialog {
//     max-width: 100%;
//     margin: 0;
//     top: 0;
//     bottom: 0;
//     left: -10px;
//     right: 0;
//     // height: 200vh;
//     // display: flex;
//     // position: fixed;
//     z-index: 100000;
// }
</style>
